<h2 mat-dialog-title>{{ 'rangeDate.title' | translate }}</h2>
<mat-dialog-content style="width: 100%; margin: 0px;">
    <div>
        <p>{{ 'rangeDate.text' | translate }}</p>

    </div>

        <div>
            <!-- <mat-form-field style="margin-right: 10px;">
                <mat-label>{{ 'rangeDate.start_date' | translate }}</mat-label>
                <input matInput type="datetime" name="start_date" formControlName="start_date">
                <mat-icon matSuffix>calendar</mat-icon>
            </mat-form-field>
            <mat-form-field style="margin-left:10px">
                <mat-label>{{ 'rangeDate.end_date' | translate }}</mat-label>
                <input matInput type="datetime" name="end_date" formControlName="end_date">
                <mat-icon matSuffix>date</mat-icon>
            </mat-form-field> -->
            <mat-form-field appearance="fill">
                <mat-label>{{ 'inputs.insert_date_range' | translate }}</mat-label>
                <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
                  <input matStartDate formControlName="start" placeholder="{{ 'inputs.start_date' | translate }}">
                  <input matEndDate formControlName="end" placeholder="{{ 'inputs.end_date' | translate }}">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker ></mat-date-range-picker>
              
                <!-- <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Invalid start date</mat-error>
                <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error> -->
              </mat-form-field>
        </div>

</mat-dialog-content>
<mat-dialog-actions>
    <button mat-flat-button mat-dialog-close>
        <span>{{'rangeDate.cancel' | translate}}</span>
    </button>
    <button mat-flat-button (click)="getRangeDate(rangeDateForm)"
        style="color: white; background-color: #5fbeb5;">
        <span>{{ 'rangeDate.ok' | translate}}</span>
    </button>
    <mat-progress-bar *ngIf="showBar" mode="indeterminate"></mat-progress-bar>
</mat-dialog-actions>